import { FloorMapsView } from "@/features/floormaps/components/FloorMapsView"

export default function FloorMapsPage() {
  return <FloorMapsView />
}